/**
 * Podmiana obrazów i plików na wersje językowe, gdy GTranslate działa
 * w trybie widgetu (plan darmowy, bez tłumaczonych adresów URL).
 *
 * Na planie płatnym z tłumaczeniem URL-i proxy GTranslate podmienia
 * data-gt-src-xx / data-gt-href-xx po stronie serwera — wtedy PHP ustawia
 * clientSide=false i ten skrypt nie robi nic.
 */
document.addEventListener('DOMContentLoaded', () => {
    const config = window.borpelleGTranslate;

    if (!config || !config.clientSide) return;

    const root = document.documentElement;
    const original = (config.originalLanguage || 'pl').toLowerCase();

    // Widget Google Translate ustawia lang na <html> po przełączeniu języka.
    const currentLanguage = () => (root.getAttribute('lang') || original).toLowerCase();

    function swap(element, attribute) {
        const backup = 'data-gt-original-' + attribute;

        if (!element.hasAttribute(backup)) {
            element.setAttribute(backup, element.getAttribute(attribute) || '');
        }

        const translated = element.getAttribute('data-gt-' + attribute + '-' + currentLanguage());
        const value = translated || element.getAttribute(backup);

        if (value && element.getAttribute(attribute) !== value) {
            element.setAttribute(attribute, value);
        }
    }

    function apply() {
        document.querySelectorAll('[data-gt-localized]').forEach(el => {
            swap(el, el.tagName === 'A' ? 'href' : 'src');
        });
    }

    apply();

    new MutationObserver(apply).observe(root, { attributes: true, attributeFilter: ['lang'] });
});
